/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PushSubscriptionKey
 */
export interface PushSubscriptionKey {
    /**
     * 
     * @type {string}
     * @memberof PushSubscriptionKey
     */
    p256dh: string;
    /**
     * 
     * @type {string}
     * @memberof PushSubscriptionKey
     */
    auth: string;
    /**
     * 
     * @type {number}
     * @memberof PushSubscriptionKey
     */
    id?: number;
}

/**
 * Check if a given object implements the PushSubscriptionKey interface.
 */
export function instanceOfPushSubscriptionKey(value: object): value is PushSubscriptionKey {
    if (!('p256dh' in value) || value['p256dh'] === undefined) return false;
    if (!('auth' in value) || value['auth'] === undefined) return false;
    return true;
}

export function PushSubscriptionKeyFromJSON(json: any): PushSubscriptionKey {
    return PushSubscriptionKeyFromJSONTyped(json, false);
}

export function PushSubscriptionKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PushSubscriptionKey {
    if (json == null) {
        return json;
    }
    return {
        
        'p256dh': json['p256dh'],
        'auth': json['auth'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function PushSubscriptionKeyToJSON(json: any): PushSubscriptionKey {
    return PushSubscriptionKeyToJSONTyped(json, false);
}

export function PushSubscriptionKeyToJSONTyped(value?: PushSubscriptionKey | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'p256dh': value['p256dh'],
        'auth': value['auth'],
        'id': value['id'],
    };
}

